(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-share"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  // Garante que o listener de ESC seja adicionado apenas uma vez,
  // mesmo que initShareCart seja chamado múltiplas vezes após refresh.
  let _escBound = false;

  // ─── Auxiliares ──────────────────────────────────────────────────────────────

  async function _fetchCart() {
    const r = await fetch('/cart.js', { cache: 'no-store' });
    return r.json();
  }

  function _buildShareUrl(cart) {
    if (!cart.items.length) return '';
    const items = cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
    const trigger = document.querySelector('[data-cart-share-open]');
    const langRoot = (trigger?.dataset.langRoot || '/').replace(/\/$/, '');
    
    let url = `${location.origin}${langRoot}/cart/${items}`;
    
    if (cart.cart_level_discount_applications?.length) {
      const d = cart.cart_level_discount_applications[0].title;
      if (d) url += `?discount=${encodeURIComponent(d)}`;
    }

    const currentLocale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en';

    url += url.includes('?') ? `&locale=${currentLocale}` : `?locale=${currentLocale}`;

    return url;
  }

  function _openModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    if (!overlay || !modal) return;
    overlay.classList.remove('hidden');
    overlay.classList.add('flex');
    overlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => {
      modal.classList.remove('scale-95', 'opacity-0');
      modal.classList.add('scale-100', 'opacity-100');
    });
  }

  function _closeModal() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const modal = document.querySelector('[data-cart-share-modal]');
    const qrBox = document.querySelector('[data-cart-share-qr-box]');
    if (!overlay || !modal) return;
    modal.classList.add('scale-95', 'opacity-0');
    modal.classList.remove('scale-100', 'opacity-100');
    setTimeout(() => {
      overlay.classList.remove('flex');
      overlay.classList.add('hidden');
      overlay.setAttribute('aria-hidden', 'true');
      if (qrBox) qrBox.classList.add('hidden');
    }, 200);
  }

  function _showToast() {
    const toast = document.querySelector('[data-cart-share-toast]');
    if (!toast) return;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) scale(1)';
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) scale(0.95)';
    }, 1500);
  }

  // ─── Ligação de eventos ───────────────────────────────────────────────────────
  // Chamada após cada refresh do drawer para religar eventos aos novos elementos.

  function _bind() {
    const overlay = document.querySelector('[data-cart-share-overlay]');
    const copyBtn = document.querySelector('[data-cart-share-copy]');
    const qrBtn   = document.querySelector('[data-cart-share-qr]');
    const qrImg   = document.querySelector('[data-cart-share-qr-img]');
    const qrBox   = document.querySelector('[data-cart-share-qr-box]');

    // Fechar ao clicar fora do modal
    overlay?.addEventListener('click', (e) => {
      if (e.target === overlay) _closeModal();
    });

    // Fechar via ESC — adicionado uma única vez no document
    if (!_escBound) {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') _closeModal();
      });
      _escBound = true;
    }

    // Copiar link
    copyBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url) return;
      await navigator.clipboard.writeText(url);
      _showToast();
    });

    // QR Code
    qrBtn?.addEventListener('click', async () => {
      const cart = await _fetchCart();
      const url = _buildShareUrl(cart);
      if (!url || !qrImg || !qrBox) return;
      qrImg.src = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(url)}`;
      qrBox.classList.remove('hidden');
    });
  }

  // Fecha o modal quando o drawer fechar
  document.addEventListener('cartDrawer:closed', _closeModal);

  // ─── Gatilho (delegação no document) ─────────────────────────────────────────
  // Usa delegação para funcionar mesmo após o trigger ser re-renderizado
  // pelo refresh do drawer.

  document.addEventListener('click', async (e) => {
    if (!e.target.closest('[data-cart-share-open]')) return;
    const cart = await _fetchCart();
    const url = _buildShareUrl(cart);
    const waBtn = document.querySelector('[data-cart-share-whatsapp]');
    if (waBtn && url) {
      waBtn.href = `https://wa.me/?text=${encodeURIComponent(`Check out my cart: ${url}`)}`;
    }
    _openModal();
  });

  // ─── Inicialização ─────────────────────────────────────────────────────────────

  window.initShareCart = () => {
    // Após refresh do drawer, re-liga os eventos aos novos elementos renderizados.
    _bind();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initShareCart);
  } else {
    window.initShareCart();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-info-details"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  function initComplementDesc() {
    var storefront = window.__STOREFRONT__;
    if (!storefront || !storefront.token) return;

    var placeholders = Array.from(document.querySelectorAll('[data-complement-desc]'));
    if (placeholders.length === 0) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        loadDesc(el, storefront);
      });
    }, { rootMargin: '100px' });

    placeholders.forEach(function (el) { observer.observe(el); });
  }

  function loadDesc(el, storefront) {
    var code      = el.getAttribute('data-look-code');
    var productId = parseInt(el.getAttribute('data-product-id'), 10);
    if (!code || code.toUpperCase() === 'NULL' || code.toUpperCase() === 'NULO' || code === '0') {
      el.remove();
      return;
    }

    var query = [
      'query {',
      '  search(query: ' + JSON.stringify(code) + ', types: PRODUCT, first: 5) {',
      '    edges { node { ... on Product { id handle } } }',
      '  }',
      '}'
    ].join(' ');

    fetch(storefront.url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefront.token
      },
      body: JSON.stringify({ query: query })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var edges = (data.data && data.data.search && data.data.search.edges) || [];
        var handle = null;
        for (var i = 0; i < edges.length; i++) {
          var node = edges[i].node;
          if (!node || !node.id) continue;
          var numId = parseInt(node.id.split('/').pop(), 10);
          if (numId !== productId) { handle = node.handle; break; }
        }
        if (!handle) { el.remove(); return; }

        var sectionName = el.getAttribute('data-complement-section') || 'pdp-complement-description';
        return fetch('/products/' + handle + '?sections=' + sectionName)
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            var html = (sections && sections[sectionName]) || '';
            if (!html.trim()) { el.remove(); return; }
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var inner = doc.querySelector('.infoDetails__complement');
            if (inner) { el.replaceWith(inner); } else { el.remove(); }
          });
      })
      .catch(function (err) {
        console.error('[ComplementDesc]', err);
        el.remove();
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initComplementDesc);
  } else {
    initComplementDesc();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
